import React, { Component } from "react";
import Modal from "./Modal";

export default class StreamDelete extends Component {
  render() {
    return (
      <div>
        <Modal />
      </div>
    );
  }
}
